import styled from "styled-components";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useSeller } from "../../../context/seller";
import format from "date-fns/format";
import removeTimezone from "../../../utils/removeTimezone";
import Modal from "../../common/Modal";
import { MdEdit } from "react-icons/md";
import { FaTrash } from "react-icons/fa6";

export default function Summary() {
    const { summary, setIsSummaryModalOpen, setEditReservationId, setConfirmDeleteReservationId } = useSeller()
    return (
        <Modal>
            <h1>Summary</h1>
            <TableWrapper>
                <Table>
                    <thead>
                        <th style={{width: '40px'}}>
                        </th>
                        <th style={{width: '40px'}}>
                        </th>
                        <th>Tour</th>
                        <th>Date</th>
                        <th>Passenger</th>
                        <th>Total price</th>
                        <th>Ticket</th>
                    </thead>
                    <tbody>
                        {
                            summary.map((item, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <button
                                        type="button"
                                        onClick={() => setEditReservationId(item.reservation.id)}
                                        style={{backgroundColor: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        >
                                            <MdEdit/>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                        onClick={() => setConfirmDeleteReservationId(item.reservation.id)}
                                        type="button"
                                        style={{backgroundColor: 'red', color: 'white', borderRadius: '5px', padding: '5px', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        >
                                            <FaTrash/>
                                        </button>
                                    </td>
                                    <td>{item.reservation.tour_id}</td>
                                    <td>{typeof item.reservation.reservation_date === 'string' ? removeTimezone(item.reservation.reservation_date) : format(item.reservation.reservation_date, 'dd/MM/yyyy')}</td>
                                    <td>{item.passenger.name}</td>
                                    <td>{item.reservation.price}</td>
                                    <td>{item.reservation.tickets}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </TableWrapper>
            <div className="close"
            onClick={() => setIsSummaryModalOpen(false)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const TableWrapper = styled.div`
width: 100%;
overflow: auto;
min-height: 80px;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 350px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`